import { addFormFields, removeFieldsById } from "../../../utils/FormFields/RemoveFields/handleRemoveFields";
import { HideShowPDFUploadConfig, HideShowRedirectUrlConfig, HideShowVideoUrlConfig, addSpeakerConfig } from "./addHideShowFields";


const handleFieldChange = (dataFieldName, updateFormData, CreateResourcesData, setScheduleType) => {
    switch (dataFieldName) {
        case "format": {
            const { format } = updateFormData;

            // First, remove all previous fields to reset the form state
            removeFieldsById(CreateResourcesData, ['videoUrl', 'ReportFileName', 'redirectUrl']);
            switch (format) {
                case "page":
                    addFormFields(CreateResourcesData,addSpeakerConfig,'format')
                    break;
                case "video":
                    addFormFields(CreateResourcesData, HideShowVideoUrlConfig, "format");
                    addFormFields(CreateResourcesData,addSpeakerConfig,'format')
                    break;
                
                case "report":
                    addFormFields(CreateResourcesData, HideShowPDFUploadConfig, "format");
                    removeFieldsById(CreateResourcesData,['speaker','displaySpeakerImage'])
                    break;
            
                case "redirectTo":
                    addFormFields(CreateResourcesData, HideShowRedirectUrlConfig, "format");
                    removeFieldsById(CreateResourcesData,['speaker','displaySpeakerImage'])
                    break;
                
                default:
                    break;
            }
            // if(format === "report" || format ==="redireTo")
            // {
            //     addFormFields(CreateResourcesData, addSpeakerConfig, "format");
            // }

            break;
        }
        // case "scheduleType": {
        //     const { scheduleType } = updateFormData;
        //     setScheduleType(scheduleType);
        //     break;
        // }
        default:
            break;
    }
};

export default handleFieldChange;


